<mat-dialog-content>
  <h1>Are You Sure?</h1>
  <p>Remove scheduled hours override for {{ override.date | date: "fullDate" }}</p>
  <div class="button-container">
    <button mat-button (click)="confirm(false)">Cancel</button>
    <button mat-raised-button color="warn" (click)="confirm(true)">Remove</button>
  </div>
</mat-dialog-content>
